import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderAdditionalCostStatusesAdapter = getAdapter({ idFieldName: 'value' });

const orderAdditionalCostStatusesSlice = createSlice({
    name: 'orderAdditionalCostStatuses',
    initialState: orderAdditionalCostStatusesAdapter.getInitialState(),
    reducers: {
        setOrderAdditionalCostStatuses: (state, { payload: { orderAdditionalCostStatuses } }) => {
            orderAdditionalCostStatusesAdapter.setAll(state, orderAdditionalCostStatuses);
        },
    },
});

const selectors = orderAdditionalCostStatusesAdapter.getSelectors(({ orderAdditionalCostStatuses }) => orderAdditionalCostStatuses);

export const getOrderAdditionalCostStatuses = (state) => selectors.selectAll(state);

export const {
    setOrderAdditionalCostStatuses,
} = orderAdditionalCostStatusesSlice.actions;

export default orderAdditionalCostStatusesSlice.reducer;
